/**
 *
 * design zone overlay for mailing services
 * handles horizontal and vertical orientations
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Matt <matt.anderson@opensoftdev.com>
 */

define(['jquery', 'assets/js/modules/utils', 'assets/js/modules/designFacePreview/mailingServicesGuides/view/abstractView'], function(
    $,
    utils,
    AbstractView
) {
    return AbstractView.extend({
        mailingGuides: null, // results of the service call to fetch product's mailing guides
        // unit basic sizing before any cuts/trims
        fullbleedWidth: 0, // width millimeters
        fullbleedHeight: 0, // height millimeters
        isVerticalOrientiation: false,

        initialize: function() {
            AbstractView.prototype.initialize.apply(this, arguments);
            this.renderOverlayZones();
        },

        renderOverlayZones: function() {
            var _this = this;
            var productPreviewInfo = this.model.get('productPreviewInfo');

            // import product measurements
            var bleedWidth = productPreviewInfo.get('zones').bleedWidth;
            var bleedHeight = productPreviewInfo.get('zones').bleedHeight;
            //todo change mailingGuides data to inches or to coefficients to avoid converting
            this.fullbleedWidth = Math.round(utils.convertInchToMillimeter(bleedWidth));
            this.fullbleedHeight = Math.round(utils.convertInchToMillimeter(bleedHeight));
            this.mailingGuides = productPreviewInfo.get('mailingGuides');
            this.isVerticalOrientiation = this.model.get('isVertical'); // determine which pixel matrix transforms would be applied

            // verify service provides mailing guides
            if (this.hasMailingGuides()) {
                // for each known shape, render an overlay
                this.mailingGuides.forEach(function(zoneMetric) {
                    var isRectangle = true; // for now, the only shape is rectangle

                    if (isRectangle) {
                        zoneMetric.transformedCanvasMatrix = _this._calculateCanvasTransformedMatrix(zoneMetric);

                        _this._renderMeasuredRectangle(
                            zoneMetric.transformedCanvasMatrix.x,
                            zoneMetric.transformedCanvasMatrix.y,
                            zoneMetric.transformedCanvasMatrix.w,
                            zoneMetric.transformedCanvasMatrix.h,
                            0,
                            _this.options
                        );
                    }
                });

                // tooltip shown
                $(this.context.canvas).mousemove(this.handleMouseMove.bind(this));
            }
        },

        // validator for ensuring there are some mailing guides established
        hasMailingGuides: function() {
            return Array.isArray(this.mailingGuides) && this.mailingGuides.length > 0;
        },

        // show tooltip when mouse hovers over zone
        handleMouseMove: function(e) {
            var targetBox = e.currentTarget.getBoundingClientRect(),
                mouseX = parseInt(e.clientX - targetBox.left),
                mouseY = parseInt(e.clientY - targetBox.top),
                hoveredZone = this.detectZoneContainmentByCoordinate(mouseX, mouseY); // see if mouse if over one of the regions, and place a tooltip

            if (hoveredZone) {
                var generatedTitle = [hoveredZone.label, hoveredZone.description].join('\n');
                // update tooltip text
                if (e.currentTarget.title !== generatedTitle) {
                    e.currentTarget.title = generatedTitle;
                }
            } else {
                e.currentTarget.title = '';
            }
        },

        // given canvas pixel coordinates, determine which zone contains it
        detectZoneContainmentByCoordinate: function(canvasX, canvasY) {
            var match;
            // for each known shape, render an overlay
            this.mailingGuides.some(function(zone, i) {
                var isRectangle = true; // for now, the only shape is rectangle
                if (isRectangle) {
                    var matrix = zone.transformedCanvasMatrix;
                    // point inside zone shape
                    if (utils.between(canvasX, matrix.x, matrix.x + matrix.w) && utils.between(canvasY, matrix.y, matrix.y + matrix.h)) {
                        // must be hovering over zone
                        match = zone;
                        return true;
                    }
                }
            });
            return match;
        },

        // run math to yield a canvas compatible coordinate set
        _calculateCanvasTransformedMatrix: function(zoneMetric) {
            var orientLeft = zoneMetric.left,
                orientTop = zoneMetric.top,
                orientWidth = zoneMetric.width,
                orientHeight = zoneMetric.height;

            // transform, if vertical
            if (this.isVerticalOrientiation) {
                orientLeft = zoneMetric.top;
                orientTop = zoneMetric.left;
                orientWidth = zoneMetric.height;
                orientHeight = zoneMetric.width;
            }

            // simplifies to matrix of points on canvas
            return {
                x: this.orientX(this.transformX(orientLeft)),
                y: this.transformY(orientTop),
                w: this.transformWidth(orientWidth),
                h: this.transformHeight(orientHeight)
            };
        },

        // places a rectangle measured in physical space into a <CANVAS> coordinate space
        _renderMeasuredRectangle: function(left, top, width, height, borderRadius, options) {
            var ctx = this.context,
                style = options.overlayZones;
            ctx.fillStyle = style.background;
            ctx.fillRect(left, top, width, height);
            ctx.strokeStyle = style.strokeColor;
            ctx.lineWidth = style.strokeWidth;
            ctx.strokeRect(left, top, width, height);
        },

        // math transform to physical CANVAS X space, given product type fullbleed dimension
        transformX: function(xCoord) {
            var c = this.context.canvas,
                coordinateSpace = this.isVerticalOrientiation ? c.height : c.width;
            return xCoord / this.fullbleedWidth * coordinateSpace;
        },

        orientX: function(xCoord) {
            if (this.isVerticalOrientiation) {
                return this.context.canvas.width - xCoord;
            } else {
                return xCoord;
            }
        },

        // math transform to physical CANVAS Y space, given product type fullbleed dimension
        transformY: function(yCoord) {
            var c = this.context.canvas,
                coordinateSpace = this.isVerticalOrientiation ? c.width : c.height;
            return yCoord / this.fullbleedHeight * coordinateSpace;
        },

        // relative units change due to flipped coordinate space on a vertical image
        transformWidth: function(xCoord) {
            return (this.isVerticalOrientiation ? -1 : 1) * this.transformX(xCoord);
        },

        // not destructive
        transformHeight: function(yCoord) {
            return this.transformY(yCoord);
        }
    });
});
